
import React from 'react';
import Settings from '../../components/Settings';
import { AppConfig, User } from '../../types';

interface SettingsTemplateProps {
  config: AppConfig;
  user: User;
  isOpen: boolean;
  onClose: () => void;
  onUpdate: (config: Partial<AppConfig>) => void;
  onUpdateUser: (userData: Partial<User>) => void;
  onLogout?: () => void;
  onDeleteAccount?: () => void;
  onRestartTour?: () => void;
  initialTab?: 'profile' | 'app' | 'security';
}

const SettingsTemplate: React.FC<SettingsTemplateProps> = (props) => {
  return (
    <Settings 
      config={props.config}
      user={props.user}
      isOpen={props.isOpen}
      onClose={props.onClose}
      onUpdate={props.onUpdate}
      onUpdateUser={props.onUpdateUser}
      onLogout={props.onLogout}
      onDeleteAccount={props.onDeleteAccount}
      onRestartTour={props.onRestartTour}
      initialTab={props.initialTab}
    />
  );
};

export default SettingsTemplate;
